module.exports = __webpack_public_path__ + "assets/img/benefit-nxercise.e398c428.png";